import { combineReducers } from 'redux';

import organization from './organization';
import subtitle from './subtitle';
import chapter from './chapter';
import media from './media';
import editor from './editor';
import ui from './ui';
import ibt from './ibt';

const rootReducer = combineReducers({ organization, ui, subtitle, chapter, media, editor, ibt });

export default rootReducer;
